import { AppAuthContext } from "@/authentication"
import { SystemRole, User } from "@/models"
import type { IdTokenClaims } from "oidc-vue"
import { ref, watch } from "vue"
import { proxyProp } from "vue-utils"

const loggedInUser = ref<User | null>(null)

watch(
	() => AppAuthContext.user,
	(newUser) => {
		if (newUser === null) {
			loggedInUser.value = null
		} else {
			loggedInUser.value = new User({
				guid: newUser.profile.sid!,
				firstName: newUser.profile.given_name ?? "",
				lastName: newUser.profile.family_name ?? "",
				emailAddress: newUser.profile.email!,
				role: getRoleFromKeyCloak(newUser.profile as ActualClaims),
			})
		}
	}
)

interface ActualClaims extends IdTokenClaims {
	realm_access: {
		roles: string[]
	}
}

function getRoleFromKeyCloak(profile: ActualClaims) {
	const roles = profile.realm_access.roles
	for (const role of roles) {
		if (Object.values(SystemRole).includes(role as SystemRole)) {
			return role as SystemRole
		}
	}
	return SystemRole.ReadOnly
}

export default function useLoggedInUser(): User {
	return proxyProp(() => {
		const user = loggedInUser.value
		if (!user) {
			throw new Error("No user is currently logged in")
		}
		return user
	})
}
